// extracted by mini-css-extract-plugin
export default {"divider":"divider__tj6ZD","imgContainer":"imgContainer__g2zc4","slideshowsTab":"slideshowsTab__eicou"};